<template>
<div class="main">
  <h2 v-if="title" class="title">{{title}}</h2>
  <el-tabs class="main-tabs" v-model="tabContent">
    <el-tab-pane
      class="main-tabs-pane"
      v-for="tab in tabList"
      :key="tab.name"
      :label="tab.label" :name="tab.name">
      <slot :name="tab.name"></slot>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
export default {
  name: 'tab-pane',
  props: {
    title: {
      type: String,
      default: ''
    },
    tabList: {
      type: Array,
      default: () => []
    },
    initIndex: {
      type: Number,
      default: 0
    },
    path: {
      type: String
    },
    tabCommon: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    tabContent (to) {
      this.$router.push({
        path: this.path || this.$router.path,
        query: { state: to }
      })
    },
    $route (to) {
      this.tabContent = to.query.state || this.tabList[this.initIndex].name
    }
  },
  data () {
    return {
      tabContent: this.$route.query.state || this.tabList[this.initIndex].name
    }
  }
}
</script>
<style scoped lang="sass">
.main
  padding: 20px
  display: flex
  flex-direction: column
  flex: 1
  height: 100%
</style>




// WEBPACK FOOTER //
// Tab.vue?46b23d22